export const convertUnits = {
  Satoshi: 'sat',
  hundredMillion: '億',
  trillion: '兆',
}

export const convertRates = {
  Satoshi: 8,
  hundredMillion: 8,
  trillion: 12,
}
